import { render } from "./CustomerListComponent.vue?vue&type=template&id=65e732ec&scoped=true"
import script from "./CustomerListComponent.vue?vue&type=script&lang=js"
export * from "./CustomerListComponent.vue?vue&type=script&lang=js"

import "./CustomerListComponent.vue?vue&type=style&index=0&id=65e732ec&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e732ec"],['__file',"resources/js/components/admin/customers/CustomerListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65e732ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65e732ec', __exports__)) {
    api.reload('65e732ec', __exports__)
  }
  
  module.hot.accept("./CustomerListComponent.vue?vue&type=template&id=65e732ec&scoped=true", () => {
    api.rerender('65e732ec', render)
  })

}


export default __exports__